import React from "react";

type Props = {
  headingpara?: string;
  classname?: string;
  subheadingpara?: string;
  heading?: string;
};

const HeadingParagrap = ({
  classname,
  headingpara,
  heading,
  subheadingpara,
}: Props) => {
  return (
    <>
      {/* mobile */}
      <div className="container-fluid d-block  d-md-none pb-30 p-20">
        <div className="d-flex font-family-roboto header-color font-30 fonts-800 line-35 justify-content-center align-items-center pb-30 para-heading">
          {heading}
        </div>
        <div
          className={`font-family-roboto fonts-400 font-28 line-32 d-flex align-items-center dark-header text-align-center pb-20 graph-subhead2 ${classname}`}
        >
          {headingpara}
        </div>
        <div
          className={`font-family-roboto fonts-400 font-28 line-32 px-30 d-flex align-items-center dark-header text-align-center graph-subhead2 ${classname}`}
        >
          {subheadingpara}
        </div>
      </div>
      {/* Website view */}
      <div className="container-fluid d-none d-md-block py-60">
        <div className="d-flex font-family-roboto header-color font-30 fonts-800 line-35 justify-content-center align-items-center pb-40 para-heading">
          {heading}
        </div>
        <div
          className={`font-family-roboto fonts-400 font-28 line-32 px-30 d-flex align-items-center dark-header text-align-center pb-20 graph-subheading ${classname}`}
        >
          {headingpara}
        </div>
        <div
          className={`font-family-roboto fonts-400 font-28 line-32 px-30 d-flex align-items-center dark-header text-align-center graph-subheading ${classname}`}
        >
          {subheadingpara}
        </div>
      </div>
    </>
  );
};

export default HeadingParagrap;
